/**
 * SF-4651 step 3: notes for Eva and up to five call transcripts. Files are checked here first
 * (type, size, count) and a refused one is never sent. Once the build is created its page sends
 * them and shows sf-api's answer for each file (SF-4729).
 */
import { Form, Input } from 'antd';
import { MAX_NOTES_LENGTH } from '../constants';
import type { ChosenTranscript } from '../transcripts';
import { TranscriptPicker } from './TranscriptPicker';

export interface NotesStepProps {
  notes: string;
  notesError: string | null;
  onNotesChange: (notes: string) => void;
  transcripts: ChosenTranscript[];
  onTranscriptsChange: (next: ChosenTranscript[]) => void;
  /** Files can no longer be changed once they have been sent. */
  locked: boolean;
}

export const NotesStep: React.FC<NotesStepProps> = ({
  notes,
  notesError,
  onNotesChange,
  transcripts,
  onTranscriptsChange,
  locked,
}) => (
  <Form layout="vertical">
    <Form.Item
      label="Notes for Eva"
      htmlFor="demo-notes"
      validateStatus={notesError ? 'error' : undefined}
      help={notesError ?? 'Anything from the call: what they care about, sites to include, tone.'}
    >
      <Input.TextArea
        id="demo-notes"
        rows={5}
        value={notes}
        showCount
        maxLength={MAX_NOTES_LENGTH}
        onChange={(e) => onNotesChange(e.target.value)}
      />
    </Form.Item>
    <TranscriptPicker
      transcripts={transcripts}
      onTranscriptsChange={onTranscriptsChange}
      locked={locked}
      pendingHint="Sent when you create the demo"
    />
  </Form>
);
